<template>
    <div class="detail-menu">
        <div class="detail-menu-item" :class="{active: value === 0}" @click="changeMenu(0)">详情介绍</div>
        <div class="detail-menu-item" :class="{active: value === 1}" @click="changeMenu(1)">机器参数</div>
        <div class="detail-menu-item" @click="$router.push('/device')">驱动下载</div>
        <div class="detail-menu-item" @click="$router.push('/afterSalesService/videos')">产品视频</div>
        <div class="detail-menu-item" v-show="false">产品手册</div>
    </div>
</template>

<script>
export default {
    name: "TopMenus",
    props: {
        value: Number
    },
    data() {
        return {};
    },
    methods: {
        changeMenu(index) {
            this.$emit("input", index);
        }
    },
};
</script>

<style lang="scss" scoped>
.detail-menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 40rem;

    .detail-menu-item {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14rem;
        color: #333333;
        line-height: 20rem;
        cursor: pointer;

        &.active {
            font-weight: 500;
            color: #FD6520;
        }
    }
}
</style>
